// extracted by mini-css-extract-plugin
module.exports = {"policyCheck":"policyCheck_policyCheck__1iPlQ"};